import React, { useEffect } from 'react';
import styled from 'styled-components';
import AOS from 'aos';
import 'aos/dist/aos.css';

const PrivacyPolicy = () => {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <Wrapper>
      <Header data-aos="fade-down">
        <h1>Privacy Policy</h1>
        <p>Effective Date: July 9, 2025</p>
      </Header>

      <Section data-aos="fade-up">
        <h2>Introduction</h2>
        <p>
          Totomart, operated by Ligiotech Solutions Pvt Ltd, is committed to protecting your personal data and
          respecting your privacy. This policy outlines how we collect, use, store, and protect your information when
          you use our platform.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>Information We Collect</h2>
        <ul>
          <li><strong>Personal Information:</strong> Name, phone number, email address, property details, etc.</li>
          <li><strong>Usage Data:</strong> IP address, browser type, access time, and user behavior analytics.</li>
          <li><strong>Payment Data:</strong> Payment method, UPI, and transaction history (processed via secure gateways).</li>
        </ul>
      </Section>

      <Section data-aos="fade-up">
        <h2>How We Use Your Information</h2>
        <ul>
          <li>To provide and personalize our services</li>
          <li>To enable communication between tenants and property owners</li>
          <li>To send updates, alerts, and transactional emails</li>
          <li>To improve user experience and security</li>
        </ul>
      </Section>

      <Section data-aos="fade-up">
        <h2>Cookies & Tracking</h2>
        <p>
          Totomart uses cookies and similar technologies to analyze usage patterns and enhance user experience. You may
          control cookie settings via your browser at any time.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>Data Sharing & Disclosure</h2>
        <p>
          We do not sell or rent your personal information. We may share data with trusted partners or service providers
          (e.g., payment gateways, background verification agencies) strictly for service delivery.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>Third-Party Services</h2>
        <p>
          Totomart may integrate services from third-party providers (like Google Maps, payment processors, etc.). Each
          third-party may have their own privacy policy, and we encourage users to review them.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>Data Security</h2>
        <p>
          We implement appropriate security measures including encryption, access controls, and secure storage to
          safeguard your data. However, no method of transmission over the Internet is 100% secure.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>Your Rights</h2>
        <p>
          You have the right to access, correct, or delete your personal data. You can update preferences by logging
          into your account or contacting us directly.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>Policy Updates</h2>
        <p>
          This Privacy Policy may be updated periodically. Changes will be posted on this page with an updated
          “Effective Date.” Continued use of the platform implies acceptance of changes.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>Contact Information</h2>
        <p>
          For any questions regarding this Privacy Policy, please contact:
        </p>
        <p>
          Totomart Support<br />
          Email: support@totomart.in<br />
          Phone: +91-7373339225<br />
          Address: No. 71, Appar Street, Thiruvalleswarar Nagar, Thirumangalam, Anna Nagar, Chennai – 600040
        </p>
      </Section>

      <FooterNote data-aos="fade-in">
        <p>Totomart – Committed to transparency and user data protection.</p>
      </FooterNote>
    </Wrapper>
  );
};

export default PrivacyPolicy;

// Styled-components
const Wrapper = styled.div`
  max-width: 1000px;
  margin: auto;
  padding: 3rem 1.5rem;
  font-family: 'Segoe UI', sans-serif;
  color: #333;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 2rem;

  h1 {
    font-size: 2.4rem;
    color: #e53935;
  }

  p {
    color: #666;
    font-size: 1rem;
  }
`;

const Section = styled.section`
  margin-bottom: 2rem;

  h2 {
    color: #b71c1c;
    font-size: 1.5rem;
    margin-bottom: 0.6rem;
  }

  p {
    font-size: 1rem;
    line-height: 1.7;
    color: #444;
  }

  ul {
    margin: 1rem 0;
    padding-left: 1.5rem;

    li {
      margin-bottom: 0.5rem;
      list-style-type: disc;
      font-size: 1rem;
      color: #444;
    }
  }
`;

const FooterNote = styled.div`
  text-align: center;
  color: #777;
  font-size: 0.95rem;
  margin-top: 3rem;
  border-top: 1px solid #eee;
  padding-top: 1.5rem;
`;
